import type { AssetWorkflowOptions } from '../../types';

export const addCarrierShipmentLaneConfigurationWorkflow: AssetWorkflowOptions = {
  workflowKey: 'addCarrierShipmentLaneConfigurationWorkflow',
  workflowType: 'addAssetWorkflow',
  assetType: 'laneSortConfigurations',
  workflowIndex: 1,
  workflowName: 'Create Carrier Shipment Lane Configuration Workflow',
  workflowDescription:
    'Create a carrier shipment lane configuration. This is the carrier specific configuration that you may add shipment lanes to.',
  workflowStepOptions: [
    {
      workflowStepKey: 'carrierSelect',
      workflowStepNavigationName: 'Carrier',
      workflowComponent: {
        singleSelect: true,
        hideServiceMethods: true,
        workflowComponentType: 'carrierServiceMethodEntry',
        prompt: 'Which carrier does this carrier shipment lane configuration apply to?',
        description: '',
        help: `If you don't see your carrier here please contact a shipium admin `,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrierId',
      },
    },
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'Enter a name for this carrier shipment lane configuration',
        description: 'How will you refer to this carrier shipment lane configuration',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a description of this carrier shipment lane configuration',
        description: '',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'shipmentLaneSelect',
      workflowStepNavigationName: 'Shipment Lanes',
      workflowComponent: {
        singleSelect: true,
        hideServiceMethods: true,
        workflowComponentType: 'shipmentLaneSelect',
        prompt: 'Which shipment lanes should be added to this carrier shipment lane configuration?',
        description: '',
        help: ``,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'laneIds',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Carrier Shipment Lane Configuration Summary',
        description: 'The carrier shipment lane configuration will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
